import script from "./MenuMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuMobile.vue?vue&type=script&setup=true&lang=ts"

import "./MenuMobile.vue?vue&type=style&index=0&id=1a6ed027&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6ed027"]])

export default __exports__